import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 提示框组件
 * 用于在指定位置显示悬浮提示内容
 */
import { useEffect, useState, forwardRef } from 'react';
import ReactDOM from 'react-dom';
/**
 * 提示框组件
 * 使用React Portal在页面任意位置渲染提示框
 */
export const Tooltip = forwardRef(({ content, position, portalId = 'tooltip-portal-root', theme = 'dark', className = '' }, ref) => {
    const [portalRoot, setPortalRoot] = useState(null);
    useEffect(() => {
        const element = document.getElementById(portalId);
        if (element) {
            setPortalRoot(element);
        }
        else {
            console.error(`Tooltip portal root element (#${portalId}) was not found in the DOM!`);
        }
    }, [portalId]);
    if (!portalRoot || !position) {
        return null;
    }
    // 内层卡片的样式
    const innerCardStyles = theme === 'dark'
        ? 'bg-interactive-emerald-flash text-white border border-interactive-emerald-flash-700'
        : 'bg-static-eggshell text-interactive-emerald-flash border border-interactive-emerald-flash';
    return ReactDOM.createPortal(
    // 外层卡片
    _jsxs("div", { ref: ref, className: "fixed z-50 p-0.5 rounded-lg bg-gray-50 shadow-lg", style: {
            top: `${position.top}px`,
            left: `${position.left}px`,
            opacity: position.opacity !== undefined ? position.opacity : 1,
            pointerEvents: 'none',
            userSelect: 'none',
            transition: 'opacity 0.2s ease-in-out',
        }, children: [_jsx("div", { className: `p-2 text-sm font-medium rounded-lg w-max max-w-xs text-left whitespace-normal ${innerCardStyles} ${className}`, children: content }), position.placement && (_jsx("div", { className: `tooltip-arrow tooltip-arrow-${position.placement}` }))] }), portalRoot);
});
Tooltip.displayName = 'Tooltip';
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map